export default "__VITE_ASSET__DXtzyskF__"